import { cn } from "@/shared/lib/cn";
import { LogoMark } from "@/shared/ui/brand/LogoMark";

interface EstateLockupProps {
  /** "dark" on the charcoal rail and art panels, "light" on paper. */
  tone?: "light" | "dark";
  /** Hide the wordmark (folded rail). */
  markOnly?: boolean;
  className?: string;
}

/** The product lockup: mark, then "404 Estate". Always left to right, never "Estate 404". */
export function EstateLockup({ tone = "light", markOnly = false, className }: EstateLockupProps) {
  return (
    <span
      dir="ltr"
      className={cn("inline-flex shrink-0 items-center gap-2.5 whitespace-nowrap", className)}
    >
      <LogoMark size={28} title={markOnly ? "404 Estate" : undefined} />
      {markOnly ? null : (
        <span
          className={cn(
            "text-[15px] font-semibold tracking-[-0.01em]",
            tone === "dark" ? "text-rail-ink" : "text-ink",
          )}
        >
          404 <span className={tone === "dark" ? "text-rail-accent" : "text-brand"}>Estate</span>
        </span>
      )}
    </span>
  );
}
